import React, { useRef } from 'react';

import { Splitter, SplitterPanel } from 'primereact/splitter'
import CallersTable from '../CallersTable';
import TextEditor from '../TextEditor';
import BottomBar from '../BottomBar';

const TV = ({ toast, setCallersBlocked, setEditorBlocked, sendMessage, notification, setNotification }) => {
    return (
        <Splitter style={{ width: '100%', height: '100%' }} layout="vertical" className='tv'>
            <SplitterPanel className="flex flex-column overflow-hidden" size={95} minSize={0}>
                <Splitter layout="horizontal">
                    <SplitterPanel className="flex flex-column relative" size={50} minSize={20}>
                        <Splitter layout="vertical">
                            <SplitterPanel className="flex flex-column overflow-hidden" size={25} minSize={0}>
                                <h1 className='p-2 m-0 text-center border-bottom-1' style={{backgroundColor: '#0d3c45', letterSpacing: '1px', borderColor: 'var(--surface-border)'}}>CALLERS</h1>
                                <CallersTable setBlocked={setCallersBlocked} toast={toast} sendMessage={sendMessage} notification={notification} editable={false}/>
                            </SplitterPanel>
                            <SplitterPanel className="flex flex-column relative" size={75} minSize={20}>
                                <h1 className='p-2 m-0 text-center border-bottom-1' style={{backgroundColor: '#0d3c45', letterSpacing: '1px', borderColor: 'var(--surface-border)'}}>NOTES</h1>
                                <TextEditor setBlocked={setEditorBlocked} toast={toast} sendMessage={sendMessage} notification={notification} editable={false}/>
                            </SplitterPanel>
                        </Splitter>
                    </SplitterPanel>
                    <SplitterPanel className="flex flex-column overflow-hidden relative" size={50} minSize={20}>
                        <h1 className='p-2 m-0 text-center border-bottom-1' style={{backgroundColor: '#0d3c45', letterSpacing: '1px', borderColor: 'var(--surface-border)'}}>COMMENTS</h1>
                        <iframe className='border-none' style={{backgroundColor: '#072429', colorScheme: 'light', flex: "1 1 0px"}} src="https://chat.restream.io/embed?token=9ca28b32-1699-4bd5-917e-89ce520350e8&theme=default-compact&alignment=bottom&msgOpacity=100&chatOpacity=0&scale=200&no-welcome"></iframe>
                        <div className='absolute w-full h-full bottom-0 left-0'></div>
                    </SplitterPanel>
                </Splitter>
            </SplitterPanel>
            <SplitterPanel className="flex flex-row p-3 gap-5 align-items-center" size={5} minSize={0} style={{backgroundColor: '#0d3c45'}}>
                <BottomBar sendMessage={sendMessage} notification={notification} setNotification={setNotification} editable={false}/>
            </SplitterPanel>
        </Splitter>
    );
}

export default TV; 